import React from 'react';
import classNames from 'classnames';

import styles from './search-bar.scss';

class SearchBar extends React.Component {
  constructor() {
    super();
  }

  onFocus(ev) {
    window.editor.keyController.requestFocus(ev.target);
  }

  render() {
    return (
      <div className={styles.searchPanel}>
        <div className={styles.search}>
          <label className={classNames(styles.searchIcon, 'svg-ico-search')} />
          <input
            onKeyUp={this.props.keyUpHandler}
            onFocus={this.onFocus}
            className={styles.fontSearchInput}
            type='text'
            autoFocus
          />
        </div>
      </div>
    );
  }
}

SearchBar.propTypes = {
  keyUpHandler: React.PropTypes.func,
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-search/search-bar.jsx